/**
 * Number helpers for form fields that are stored as integers.
 */

/**
 * A form value on its way to an Int column.
 *
 * Text inputs hand back strings, and an empty one is "" — which a GraphQL
 * `Int` rejects outright rather than reading as "not set". Anything blank or
 * unparseable becomes null; everything else becomes a whole number.
 *
 * @param {unknown} value
 * @returns {number|null}
 */
export function toIntOrNull(value) {
  if (value === null || value === undefined) return null

  const trimmed = String(value).trim()
  if (!trimmed) return null

  const n = Number(trimmed)

  return Number.isFinite(n) ? Math.trunc(n) : null
}

/**
 * A Vuetify rule: blank, or a whole number of at least `min`.
 *
 * Blank passes — these fields are optional, and a required-ness rule is the
 * caller's to add.
 *
 * @param {string} label - Shown in the message ("Availability Hours").
 * @param {number} [min]
 * @returns {(value: unknown) => true|string}
 */
export function wholeNumberRule(label, min = 0) {
  return value => {
    const trimmed = String(value ?? '').trim()
    if (!trimmed) return true

    const n = Number(trimmed)

    if (!Number.isFinite(n) || !Number.isInteger(n)) {
      return `${label} must be a whole number`
    }

    return n >= min ? true : `${label} can't be less than ${min}`
  }
}
